import { useContext } from 'react'

import { ScreenSizeContext } from '@/providers/ScreenSizeProvider'

export const useScreenSize = () => {
  return useContext(ScreenSizeContext)
}
